import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem ,TextField } from "@mui/material";
import {EditOutlined ,DeleteOutline , History} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { Box } from '@mui/material';
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from 'react-router-dom';
import {

  Paper,
  
  Breadcrumbs,
  
  Switch,
  
 
  Divider,
  FormControlLabel,
} from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import _ from "lodash";





const ReferralSettings = () => {
  return (
    <Box
      // sx={{
      //   background: "#cb1616",
      //   minHeight: "100vh",
      //   p: 3,
      // }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: "22px",
          p: 5,
          background: "#fff",
        }}
      >
        {/* Header */}

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={7}
        >
          <Typography
            sx={{
              fontSize: 42,
              fontWeight: 700,
              color: "#111",
            }}
          >
            Referral Settings
          </Typography>

          <Breadcrumbs separator="/">
            <Link underline="none" color="#8b8b8b">
              Admin
            </Link>

            <Typography
              sx={{
                fontWeight: 600,
                color: "#111",
              }}
            >
              Referral Settings
            </Typography>
          </Breadcrumbs>
        </Box>

        {/* Reward */}

        <Typography
          sx={{
            fontWeight: 600,
            fontSize: 15,
            mb: 2,
          }}
        >
          Referrer Reward Type
        </Typography>

        <FormControlLabel
          control={<Switch color="error" />}
          label="Disabled"
        />

        <Box mt={7} />

        {/* Row */}

        <Grid container spacing={8}>
          <Grid item md={6}>
            <Typography
              sx={{
                fontWeight: 600,
                mb: 2,
              }}
            >
              Referral Type
            </Typography>

            <FormControlLabel
              control={<Switch color="error" />}
              label="First Ride Free"
            />
          </Grid>

          <Grid item md={4}>
            <Typography
              sx={{
                fontWeight: 600,
                mb: 2,
              }}
            >
              Percentage
            </Typography>

            <TextField
              fullWidth
              size="small"
              variant="outlined"
            />
          </Grid>
        </Grid>

        <Divider sx={{ mt: 6, mb: 4 }} />

        <Button
          variant="contained"
          startIcon={<SaveOutlinedIcon />}
          sx={{
            background: "#000",
            width: 320,
            height: 56,
            borderRadius: "4px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 18,
            "&:hover": {
              background: "#111",
            },
          }}
        >
          Update Referral Settings
        </Button>
      </Paper>
    </Box>
  );
};

export default ReferralSettings;

